// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2v3Nr","item":"PaymentsMobile_item__x0K6d","label":"PaymentsMobile_label__1lfOu","amount":"PaymentsMobile_amount__2hrPK"};